/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Modal, { ModalHeader } from '../../../../components/Modal'
import Filters from '../../../../components/Filters'
import Button from '../../../../components/Button'
import { ControlTable } from '../../../../components/Table';
import useForm from '../../../../hooks/useForm';
import { getBankTransRecordListEach } from '../../../../apis/finances/bank';
import { getParams } from '../../../../utils/params';
import { get, isEmpty } from 'lodash';
import { getDay } from '../../../../utils/date';

const TagBankTransModal = ({ open, setOpen, tagForm, setTagForm }) => {
  const [fields] = useState([
    {
      title: "거래일자", key: "tradeTime", type: 'date'
    },
    {
      title: "입금액", key: "inAmt", type: 'comma', className: 'color-red-100'
    },
    {
      title: "출금액", key: "outAmt", type: 'comma', className: 'color-purple-100'
    },
    {
      title: "거래자명", key: "traderName"
    },
    {
      title: "입금자명", key: "sendBankAccountHolder"
    },
    {
      title: "적요", key: "remark"
    },
    {
      title: "적요(상세)", key: "detail"
    },
    {
      title: "메모", key: "memo"
    },
    {
      title: "거래처",
      key: "clients[0].name",
    },
  ]);
  const [filters] = useState([
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: 'range.tradeTime'
    },
  ]);

  const cancel = () => {
    setOpen(false)
    reset()
  }
  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedData, setSelectedData,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      order: [
        {
          tradeTime: "desc"
        },
      ],
      range: {
        tradeTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    if (open)
    {
      submit(form);
      setSubmit(submit)
      setSelectedData({})
    }
  }, [open]);

  const submit = (params) => {
    getBankTransRecordListEach(getParams(params))
      .then((res) => {
        setTotal(get(res, 'data.totalCount'))
        setList(get(res, 'data.transList'))
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false)
      });
  };

  const handleApply = () => {
    if (isEmpty(selectedData)) return

    setTagForm({
      ...tagForm,
      bankTransIdx: selectedData.idx,
      traderNameText: selectedData.traderName,
      sendBankAccountHolderText: selectedData.sendBankAccountHolder,
      remarkText: selectedData.remark,
      detailText: selectedData.detail,
    })
    cancel()
  }

  return (
    <Modal isOpen={open} close={cancel}>
      <div>
        <ModalHeader>은행 입출금 내역 리스트</ModalHeader>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange} />
        <ControlTable
          fields={fields}
          list={list}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          isSelect={true}
          submit={handleSubmit}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleApply}
            disabled={isEmpty(selectedData)}
          />
        </div>
      </div>
    </Modal>
  )
}

export default TagBankTransModal;